import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { selectQuizFunnel } from '@app/_store/features/quiz-funnel/quiz-funnel.selectors';
import { Store } from '@ngrx/store';
import { of, switchMap } from 'rxjs';

export const AppStateGuard: CanActivateFn | CanActivateChildFn = ({
  queryParams,
}) => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select(selectQuizFunnel).pipe(
    switchMap((quizState) => {
      const quizActive = !!quizState?.state && quizState?.state !== 'completed';

      if (quizActive) {
        router.navigate(['/start'], { queryParams });

        return of(false);
      } else {
        return of(true);
      }
    })
  );
};
